
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

interface ApiTranslateInputProps {
    locale: string;
    text: string;
}

type ApiTranslateOutputProps = OutputBaseProps<string, ApiTranslateInputProps>

export const apiTranslate = async (data: ApiTranslateInputProps) => {
    const res = (await axios.post<ApiTranslateOutputProps>("/api/translate", data))
        .data;
    return res;
};